<template>
  <div class="common-background">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <el-select class="select-as-label m-r-8 w-120" v-model="searchKey" placeholder="请选择">
        <el-option v-for="item in searchKeyList" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-input class="w-120 m-r-8" v-model="filters.search.searchKey" placeholder="请输入"></el-input>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">用户类型：</span>
        <el-select class="w-120 m-r-8" v-model="filters.search.userType">
          <el-option v-for="item in userTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </div>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">角色：</span>
        <el-select class="w-120 m-r-8" v-model="filters.search.roleId">
          <el-option v-for="item in roleList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </div>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">区域：</span>
        <AreaCascader class="w-120" v-model="filters.search.location" :end-level="2" :clearable="true" />
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>

    <div class="page-operate-block">
      <div class="tit"></div>
      <div>
        <el-button
          v-permission="'add'"
          class="operate-btn"
          @click="handleNewUser"
          >新增</el-button
        >
        <el-button
          v-permission="'update'"
          class="operate-btn"
          @click="handleEditRow"
          :disabled="this.options.selection.length != 1"
          >编辑</el-button
        >
        <el-button
          v-permission="'delete'"
          class="operate-btn"
          @click="handleDeleteRow"
          :disabled="this.options.selection.length == 0"
          >删除</el-button
        >
        <!-- <el-button
          v-permission="'export'"
          class="operate-btn"
          @click="handleUserImport"
          >导出</el-button
        > -->
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <el-table-column prop="account" label="用户名">
          <template #default="scope">
            <a @click.prevent="handleDetail(scope.$index, scope.row)">{{ scope.row.account }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="真实姓名"> </el-table-column>
        <el-table-column prop="phoneNum" label="手机号"> </el-table-column>
        <el-table-column prop="userTypeName" label="用户类型">
        </el-table-column>
        <el-table-column prop="roleNames" label="角色">
          <template #default="scope">
            {{ getRoleName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="location" label="管辖区域" show-overflow-tooltip>
          <template #default="scope">
            {{ getAddress(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="使用状态">
          <template #default="scope">
            <el-switch
              @change="handlerChangeStatus(scope.row)"
              v-model="scope.row.status"
              :disabled="!updatePerm"
              :active-value="1"
              :inactive-value="2"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="loginTimes" label="登录次数">
        </el-table-column>
      </r-table>
    </div>

    <RModal
      :title="modalTitle"
      v-model="addModal"
      width="800px"
      @change="addModal = false"
      @close="addModal = false"
    >
      <template #content>
        <userForm
          ref="user-form-modal"
          :add-modal="addModal"
          :role-list="roleList"
          :user-type-list="userTypeList"
          :user-info="curUser"
          :show-type="showType"
          @success="handleOperSuccess"
        ></userForm>
      </template>
    </RModal>
  </div>
</template>
<script>
import mixin from "@/components/common/tableMixin";
import RModal from "@/components/common/RModal";
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
import userForm from "./userForm";
import AreaCascader from '@/components/common/areaCascader'

export default {
  name: "user",
  mixins: [mixin, tableMix],
  components: {
    RModal,
    RTable,
    userForm,
    AreaCascader,
  },
  data() {
    return {
      searchKey: 'account',
      roleList: [],
      searchKeyList: [
        { value: 'account', label: '用户名' },
        { value: 'phoneNum', label: '手机号码' }
      ],
      userTypeList: [ // 1-超管，2-管理员，3-审核，4-经营者，5-管家，6-运维APP人员，7-租客
        // { value: 1, label: '超管' },
        { value: 2, label: '管理员' },
        { value: 3, label: '审核' },
        { value: 4, label: '经营者' },
        { value: 5, label: '管家' },
        { value: 6, label: '运维APP人员' },
        { value: 7, label: '租客' },
      ],

      perms: [],
      updatePerm: false,
      tableVarity: "system-manage-userinfo",
      addModal: false,
      curUser: {},
      curSelectedUserId: "",
      modalTitle: "详情",
      showType: "",
      tableData: [],
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },

      filters: {
        search: {
          searchKey: "",
          userType: "",
          roleId: "",
          location: [],
        },
      },
      filter: {
        maintainMan: "",
        orderBy: "loginTime",
        order: "desc",
      },
      userToExcel: false,
    };
  },
  created() {
    this.perms =
      "perms" in localStorage && localStorage.perms !== ""
        ? JSON.parse(localStorage.perms)
        : [];
    
    this.getRoleList()
  },
  mounted() {
    this.$nextTick(() => {
      this.updatePerm = this.isShowBtn("update");
    });

    this.pagination.pageIndex = 1;
  },
  methods: {
    // 是否拥有这个权限
    isShowBtn(perm) {
      const getPermsByUrl = (url, menus) => {
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].path === url) {
            return menus[i].children;
          }
          if (menus[i].children) {
            let perms = getPermsByUrl(url, menus[i].children);
            if (perms) return perms;
          }
        }

        return;
      };

      let url = window.location.pathname.substr(5);
      let menus = JSON.parse(window.localStorage.getItem("menu"));
      let perms = getPermsByUrl(url, menus);

      let isShow = false;

      if (!perms || !perms.length) {
        isShow = false;
      } else {
        for (let i = 0; i < perms.length; i++) {
          if (perms[i].perm === perm) {
            isShow = true;
            break;
          }
        }
      }

      return isShow
    },
    handleOperSuccess() {
      this.addModal = false;
      this._reloadData();
    },
    // 获取权限名称
    getRoleName(row) {
      for (let i = 0; i < this.roleList.length; i++) {
        if (this.roleList[i].id == row.roleId) return this.roleList[i].name
      }
    },
    // 获取区域地址
    getAddress(row) {
      if (row.areaNationwide) {
        return '全国'
      }
      return `${row.province || ''} ${row.city || ''} ${row.region || ''} ${row.streetOffice || ''} ${row.neighborCmm || ''}`;
    },
    // 获取角色列表
    getRoleList() {
      let params = {}
      let url = 'ROLE.POST_ALL'
      this.fetchData({ url, method: 'post', params }).then((res) => {
        this.roleList = res || []
      }).finally(() => {
        this._fetch()
      })
    },
    // 获取列表数据
    _fetch() {
      let params = {
        roleId: this.filters.search.roleId,
        userType: this.filters.search.userType,
        current: this.pagination.pageIndex,
        size: this.pagination.pageSize,
      };
      params[this.searchKey] = this.filters.search.searchKey
      if (this.filters.search.location) {
        params.area = this.filters.search.location[2]
      }

      this._requestData();
      let url = "USER.POST_USER_LIST";
      this.fetchData({
        url,
        method: "post",
        params,
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          this._receiveData();
          if (params.toExcel) {
            this.userToExcel = false;
            window.location.href = res.data;
            return;
          }
          this.pagination.total = res && res.total;
          this.tableData = this._getter(res.list) || [];

          if (
            res.total ===
              (this.pagination.pageIndex - 1) * this.pagination.pageSize &&
            this.pagination.pageIndex != 1
          ) {
            this.pagination.pageIndex--;
            this._reloadData();
          }
        })
        .catch((err) => {
          this._receiveData();
        });
    },
    _getter(items) {
      return items.map((data, index) => {
        Object.keys(data).forEach(function (key) {
          if (data[key] === null) {
            data[key] = "";
          }
        });
        return data;
      });
    },
    // 页码变动查询
    handlePageChange(val, opt) {
      this.pagination.pageIndex = val;
      this.pagination.pageSize = opt;
      this._reloadData();
    },
    handleSearch() {
      this.pagination.pageIndex = 1;
      this._reloadData();
    },
    _reloadData() {
      //强制请求数据
      this.refreshData();
      this._fetch();
    },
    handlerChangeStatus(row) {
      let url = "USER.POST_UPDATE_STATUS";
      let params = {
        id: row.id,
        status: row.status
      };
      this.fetchData({
        url,
        method: "post",
        params
      })
        .then((res) => {
          this.$message.success('修改成功！')
          this._reloadData();
        })
        .catch((err) => {
          this.$message.error(err)
        });
    },
    handleEditRow() {
      if (this.options.selection.length === 1) {
        this.handleEdit(0, this.options.selection[0]);
      } else {
        this.$message.error("仅支持单条数据编辑！")
      }
    },
    handleEdit(index, row) {
      this.curUser = row
      this.showType = "editUser";
      this.modalTitle = "编辑";
      this.addModal = true;
    },
    handleDetail(index, row) {
      this.curUser = row
      this.showType = "showUser";
      this.modalTitle = "详情";
      this.addModal = true;
    },
    handleNewUser() {
      this.curUser = {}
      this.showType = "newUser";
      this.modalTitle = "新增";
      this.addModal = true;
    },
    handleDeleteRow() {
      this.$confirm(`确定删除当前选中的（${this.options.selection.length}条记录）信息吗？`, { type: "warning" }).then(() => {
        this.handleDelete();
      });
    },
    handleDelete() {
      let url = "USER.POST_DELETE";
      let ids = [];
      this.options.selection.map((item) => {
        ids.push(item.id);
      });
      let params = ids.map(item => `ids=${item}`).join('&');
      this.fetchData({ url, method: "post", params, isGetParamsDirect: true })
        .then(() => {
          this.$message.success("删除成功！")
          this._reloadData();
        })
        .catch((err) => {
          this.$message.error(err)
        });
      $("body").trigger("click");
    },
    // sortChange(column, prop, order) {
    //   this.filters.search.orderBy =
    //     column.prop === "loginTime" ? "loginTime" : "";
    //   this.filters.search.order = column.order === "ascending" ? "asc" : "desc";
    //   this._reloadData();
    // },
    handleUserImport() {
      this.userToExcel = true;
      this._reloadData();
    },
  },
};
</script>
<style lang="less">
.el-popover__title {
  font-size: 14px;
}
.el-table-filter {
  background-color: @base-color;
  border: 1px solid @border-line-color;
  .el-table-filter__list-item:hover {
    background-color: @table-bg-hover;
  }
}
</style>
<style lang="less" scoped>
.theme-darkblue .m-r-xs:last-of-type {
  margin-right: 0px !important;
}
</style>
